import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { Tab } from "../components/tabset/Tab";
import { Tabset } from "../components/tabset/Tabset";

export interface TabCloseListener extends EventListener<TabCloseEvent> {
}

export class TabCloseEvent extends Event<Tab> {
    constructor(target: Tab, domEvent?: Event | DomEvent) {
        super(target, domEvent);
    }

    get userInitiatedChange() {
        return this.domEvent != null;
    }

    get tabset(): Tabset {
        return this.target.tabset;
    }
}
